import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { SearchBaseDtoPaginationResponse } from './search-base-dto-pagination-response.type';
import { SearchBookmarkDtoPaginationResponse } from './search-bookmark-dto-pagination-response.type';

const SearchDefaultResponse = t.type(
  {
    favoriteEntities: nullable(SearchBaseDtoPaginationResponse),
    recentlyVisitedEntities: nullable(SearchBaseDtoPaginationResponse),
    bookmarks: nullable(SearchBookmarkDtoPaginationResponse),
  },
  'SearchDefaultResponse',
);

type SearchDefaultResponse = t.TypeOf<typeof SearchDefaultResponse>;
export { SearchDefaultResponse };
